import { render, staticRenderFns } from "./DisabledBlocksModal.vue?vue&type=template&id=6b20d37f&"
import script from "./DisabledBlocksModal.vue?vue&type=script&lang=ts&"
export * from "./DisabledBlocksModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports